import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const fetchObjectTypes = async () => {
  const client = await getFrameworkDataSchemasClient();
  return client.frameworkTypes.getObjects();
};